<template>
  <div @click="handleClick">
    <sr-timer-btn ref="timerRef" :disabled="DISABLED.TIMER"></sr-timer-btn>
  </div>
</template>

<script>
import { toRefs, reactive, computed } from 'vue'
import { sendMobilePhoneCode } from '@/api/modules/user'
// import { platformChannel } from '@/config/setting.config'
import { validator } from '@libs/utils'
import { components } from '@libs/ui'

export default {
  name: 'sr-cellphone-code-btn',
  components: {
    SrTimerBtn: components.SrTimerBtn
  },
  props: {
    zoneNumber: {
      type: String,
      default: '+86'
    },
    cellphone: {
      type: String,
      default: ''
    },
    smsId: {
      type: String,
      default: ''
    }
  },
  setup(props, ctx) {
    const state = reactive({
      operatorFlag: true
    })

    const ref = reactive({
      timerRef: null
    })

    const scopedComputed = {
      DISABLED: computed(() => {
        return {
          TIMER: (function() {
            return !props.zoneNumber || !validator.isMobilePhone(props.cellphone, props.zoneNumber === '+86' ? '' : 'any')
          })()
        }
      })
    }

    const scopedMethods = {
      handleClick: () => {
        if (scopedComputed.DISABLED.value.TIMER) {
          return false
        }

        scopedMethods.sendCellphoneCode()
      },
      sendCellphoneCode: async () => {
        try {
          const result = await sendMobilePhoneCode({
            zoneNumber: props.zoneNumber,
            mobile: props.cellphone,
            // platformChannel
          })
          ref.timerRef.startTimer()

          ctx.emit('update:smsId', result.smsId)
        } catch (e) {
          console.log(`%c 错误捕捉`, 'color:#f00', e)
        }
      }
    }

    return {
      ...toRefs(state),
      ...toRefs(ref),
      ...scopedComputed,
      ...scopedMethods
    }
  }
}
</script>

<style scoped>

</style>
